import styled from 'styled-components';
import {
  DOC_CARD_TEMPLATE_COLUMNS,
  SUPERVISOR_DOC_CARD_TEMPLATE_COLUMNS,
} from '../../../../app/pages/Documents/style';

export const DocumentsCard = styled.div`
  position: relative;
  background-color: ${(props) => props.theme.colors.white};
  box-shadow: 0px 4px 20px rgba(104, 104, 104, 0.1);
  border-radius: 4px;
  display: grid;
  grid-template-columns: ${DOC_CARD_TEMPLATE_COLUMNS};
  align-items: center;
  gap: 24px;
  height: 100px;

  &.supervisor-documents {
    grid-template-columns: ${SUPERVISOR_DOC_CARD_TEMPLATE_COLUMNS};
  }

  > * {
    display: flex;
    align-items: center;
  }

  .file-icon {
    justify-content: center;
  }

  .title {
    cursor: pointer;
    color: ${(props) => props.theme.colors.link};
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .ellipsis {
    display: block;
    line-height: 100px;
  }
`;

export const MobileCard = styled.div`
  display: grid;
  grid-template-columns: 90px 1fr;
  row-gap: 16px;
  padding: 18px 0 25px;
  border-bottom: 1px solid #8b8b8b;

  h5 {
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 16px;
    text-transform: uppercase;
    color: #646464;
  }

  *:nth-child(even) {
    justify-self: end;
    text-align: right;
  }
`;
